import {GQLResponse} from "../../gqlModel/types";
import {TaskListUnit} from "../../../API";
import {queryGqlApi} from "../../../graphql/queryGqlApi";
import {listTaskListUnits as listTaskListUnitsGql} from "../../../graphql/tasks/queries";
import { IDataClientService } from '../../../platform/services/data/DataClientService';
import { IAuthService } from '../../../platform/services/auth/AuthService';


export const listTaskListUnits = async (
    dataClientService: IDataClientService,
    authService: IAuthService,
    wsId: string, 
    nextToken?: string, 
    limit?: number
): Promise<GQLResponse<TaskListUnit>> => {
    const response = await queryGqlApi(
        listTaskListUnitsGql,
        {
            workspaceId: wsId,
            limit: limit,
            nextToken: nextToken
        },
        dataClientService,
        authService,
        'pgServer'
    );
    return response as GQLResponse<TaskListUnit>;
}